import { Fragment } from 'react';
import { cn } from '@/shared/lib/cn';
import { breadcrumbSegments } from './akteBrowserNav';
import { AKTE_ROOT_LABEL, folderDisplayName } from './akteFolderNames';

interface Props {
  path: string;
  onNavigate: (path: string) => void;
}

/** Breadcrumb „Akte / Rechnungen / 2026 / Mai" — jedes Segment navigiert in den Ordner. */
export function AkteBreadcrumb({ path, onNavigate }: Props) {
  const crumbs = breadcrumbSegments(path);

  return (
    <nav aria-label="Ordnerpfad" className="flex min-w-0 flex-wrap items-center gap-y-1 text-base">
      <Crumb
        label={AKTE_ROOT_LABEL}
        onClick={() => onNavigate('')}
        current={crumbs.length === 0}
        tooltip={AKTE_ROOT_LABEL}
      />
      {crumbs.map((c, i) => (
        <Fragment key={c.path}>
          <span className="text-ink-faint shrink-0" aria-hidden>
            /
          </span>
          <Crumb
            label={folderDisplayName(c.path)}
            // Der technische Ordnername bleibt als Tooltip erreichbar, führt aber nicht mehr.
            tooltip={c.path}
            onClick={() => onNavigate(c.path)}
            current={i === crumbs.length - 1}
          />
        </Fragment>
      ))}
    </nav>
  );
}

function Crumb({
  label,
  tooltip,
  onClick,
  current,
}: {
  label: string;
  tooltip: string;
  onClick: () => void;
  current: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-current={current ? 'page' : undefined}
      className={cn(
        'flex min-h-11 max-w-[18ch] items-center truncate rounded px-1.5 transition-colors',
        current ? 'text-ink font-medium' : 'text-ink-faint hover:text-ink',
      )}
      title={tooltip}
    >
      {label}
    </button>
  );
}
